const BONSAIS = [
  {
    name: "Ficus Retusa",
    age: "32 yrs",
    origin: "Maharashtra",
    img: "https://images.unsplash.com/photo-1599598177991-ec67b5c37318?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxib25zYWklMjB0cmVlfGVufDB8fHx8MTc3OTA5NTE3Mnww&ixlib=rb-4.1.0&q=85",
    span: "tall",
  },
  {
    name: "Juniperus Procumbens",
    age: "18 yrs",
    origin: "Japan",
    img: "https://images.unsplash.com/photo-1470364693235-a4fe27c60914?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxib25zYWklMjB0cmVlfGVufDB8fHx8MTc3OTA5NTE3Mnww&ixlib=rb-4.1.0&q=85",
    span: "wide",
  },
  {
    name: "Ulmus Parvifolia",
    age: "24 yrs",
    origin: "China",
    img: "https://images.unsplash.com/photo-1641412722397-3be359096577?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxib25zYWklMjB0cmVlfGVufDB8fHx8MTc3OTA5NTE3Mnww&ixlib=rb-4.1.0&q=85",
    span: "tall",
  },
];

export default function Bonsai() {
  return (
    <section
      id="bonsai"
      data-testid="bonsai-section"
      className="relative bg-[#F2EFEB] py-24 sm:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        {/* Section header */}
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-8 mb-16 sm:mb-20">
          <div className="reveal max-w-2xl">
            <p className="text-[11px] tracking-[0.4em] uppercase text-[#5C6658] mb-6">
              06 / Bombay Bonsai
            </p>
            <h2 className="font-[Outfit] font-extralight text-[#2D332B] text-[36px] sm:text-[56px] leading-[1.02] tracking-[-0.015em]">
              Curated specimens,
              <br />
              <span className="italic text-[#8A9A86]">decades in the making.</span>
            </h2>
          </div>
          <p className="reveal text-[14px] leading-relaxed text-[#5C6658] max-w-sm">
            Each tree in our atelier is hand-selected and shaped over years —
            a living sculpture, available for private acquisition or studio
            placement.
          </p>
        </div>

        {/* Asymmetric gallery */}
        <div className="grid grid-cols-1 sm:grid-cols-12 gap-6 sm:gap-8">
          {/* Tall portrait */}
          <article
            data-testid="bonsai-card-0"
            className="reveal sm:col-span-5 group"
          >
            <div className="relative overflow-hidden rounded-sm aspect-[4/5]">
              <img
                src={BONSAIS[0].img}
                alt={BONSAIS[0].name}
                className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-[1.05]"
              />
              <span className="absolute top-4 left-4 bg-[#F9F8F6]/90 backdrop-blur px-3 py-1.5 text-[10px] tracking-[0.25em] uppercase text-[#2D332B]">
                {BONSAIS[0].age}
              </span>
            </div>
            <div className="mt-6 flex items-end justify-between">
              <div>
                <h3 className="font-[Outfit] font-light text-[22px] text-[#2D332B] italic">
                  {BONSAIS[0].name}
                </h3>
                <p className="mt-1 text-[11px] tracking-[0.25em] uppercase text-[#5C6658]">
                  {BONSAIS[0].origin}
                </p>
              </div>
              <span className="text-[10px] tracking-[0.3em] uppercase text-[#8A9A86]">
                №01
              </span>
            </div>
          </article>

          {/* Right column: text card + wide image */}
          <div className="sm:col-span-7 grid grid-cols-1 gap-6 sm:gap-8">
            <article
              data-testid="bonsai-card-1"
              className="reveal group"
            >
              <div className="relative overflow-hidden rounded-sm aspect-[16/10]">
                <img
                  src={BONSAIS[1].img}
                  alt={BONSAIS[1].name}
                  className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-[1.05]"
                />
                <span className="absolute top-4 left-4 bg-[#F9F8F6]/90 backdrop-blur px-3 py-1.5 text-[10px] tracking-[0.25em] uppercase text-[#2D332B]">
                  {BONSAIS[1].age}
                </span>
              </div>
              <div className="mt-6 flex items-end justify-between">
                <div>
                  <h3 className="font-[Outfit] font-light text-[22px] text-[#2D332B] italic">
                    {BONSAIS[1].name}
                  </h3>
                  <p className="mt-1 text-[11px] tracking-[0.25em] uppercase text-[#5C6658]">
                    {BONSAIS[1].origin}
                  </p>
                </div>
                <span className="text-[10px] tracking-[0.3em] uppercase text-[#8A9A86]">
                  №02
                </span>
              </div>
            </article>

            <div className="grid grid-cols-12 gap-6 sm:gap-8">
              <article
                data-testid="bonsai-card-2"
                className="reveal col-span-7 group"
              >
                <div className="relative overflow-hidden rounded-sm aspect-[3/4]">
                  <img
                    src={BONSAIS[2].img}
                    alt={BONSAIS[2].name}
                    className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-[1.05]"
                  />
                  <span className="absolute top-4 left-4 bg-[#F9F8F6]/90 backdrop-blur px-3 py-1.5 text-[10px] tracking-[0.25em] uppercase text-[#2D332B]">
                    {BONSAIS[2].age}
                  </span>
                </div>
                <div className="mt-6 flex items-end justify-between">
                  <div>
                    <h3 className="font-[Outfit] font-light text-[22px] text-[#2D332B] italic">
                      {BONSAIS[2].name}
                    </h3>
                    <p className="mt-1 text-[11px] tracking-[0.25em] uppercase text-[#5C6658]">
                      {BONSAIS[2].origin}
                    </p>
                  </div>
                  <span className="text-[10px] tracking-[0.3em] uppercase text-[#8A9A86]">
                    №03
                  </span>
                </div>
              </article>

              <div className="reveal col-span-5 bg-[#2D332B] text-[#F9F8F6] p-8 sm:p-10 flex flex-col justify-between rounded-sm">
                <span className="text-[10px] tracking-[0.3em] uppercase text-[#B4C2AF]">
                  Bombay Bonsai
                </span>
                <div className="mt-8">
                  <p className="font-[Outfit] font-light text-[26px] sm:text-[30px] leading-[1.15]">
                    Request appointment.
                  </p>
                  <a
                    href="#contact"
                    data-testid="bonsai-cta-appointment"
                    className="mt-8 inline-flex items-center text-[11px] tracking-[0.3em] uppercase border-b border-[#F9F8F6] pb-1 hover:text-[#B4C2AF] hover:border-[#B4C2AF] transition-colors"
                  >
                    Get in touch →
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
